//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import TableStatus from '@/components/_common/Table/TableStatus';
import OrdersProgressBar from './OrdersProgressBar';
import OrdersRowExpand from './OrdersRowExpand';
import DateTimeDisplay from '../_common/DateTimeDisplay';
import UserDisplay from '../_common/AssigneeSelect/UserDisplay';
import EditableTextCell from '../_common/EditableTextCell';
import { Order, OrderDetail, OrderJob } from '@/redux/slices/slice_types';
import OrdersOverflowMenu from './OrdersOverflowMenu';

export default {
  expandable: {
    label: '',
    isExpandable: true,
    disableExpand: (row: OrderDetail) => row.status === 'draft' || row.order_type === 'bulk',
    render: (props: { item: Order; isCollapsed: boolean }) => {
      const extraColumns = [
        {
          label: 'Version',
          width: 200,
          render: (job: OrderJob) => job.version?.name || '-'
        }
      ];
      return <OrdersRowExpand extraColumns={extraColumns} {...props} />;
    }
  },
  hid: {
    label: 'Order ID',
    clickCopy: true,
    sortField: 'id',
    maxWidth: 65,
    render: (cell: OrderJob['id']) => <strong>{cell || '-'}</strong>
  },
  description: {
    label: 'Description',
    clickCopy: true,
    minWidth: 210,
    render: (cell: OrderJob['description'], row: OrderDetail) => (
      <EditableTextCell value={cell} row={row} update="order" field="description" emptyText="-" />
    ),
    required: true
  },
  total_jobs: {
    label: 'Job(s)',
    disableSort: true,
    render: (cell: OrderJob['total_jobs']) => (cell > 0 ? cell : '-')
  },
  po_number: {
    label: 'PO #',
    minWidth: 210,
    render: (cell: Order['po_number'], row: OrderDetail) => (
      <EditableTextCell value={cell} row={row} update="order" label="PO #" field="po_number" emptyText="-" />
    )
  },
  managed_by_user: {
    label: 'Managed by',
    minWidth: 100,
    disableSort: true,
    // when all clients support changing managed_by, we can use this
    // render: (cell, row: Order) => <AssigneeSelect value={cell} id={row.id} row={row} update="order" assigns="user" emptyText="-" />
    render: (cell: Order['managed_by_user'], row: Order) => (cell ? <UserDisplay user={cell} emptyText="-" /> : row.managed_by) || '-'
  },
  billable_customer: {
    label: 'Billable Customer'
  },
  created_at: {
    label: 'Created',
    clickCopy: true,
    width: 100,
    render: (cell: OrderDetail['created_at']) => <DateTimeDisplay>{cell}</DateTimeDisplay>
  },
  status: {
    label: 'Status',
    render: (cell: OrderDetail['status']) => <TableStatus status={cell} />
  },
  jobs: {
    label: 'Progress',
    width: 100,
    disableSort: true,
    render: (jobs: Order['jobs'], row: Order) => <OrdersProgressBar jobs={jobs} order={row} />
  },
  overflow: {
    label: '',
    isOverflow: true,
    width: 50,
    render: (_cell: any, row: Order) => <OrdersOverflowMenu order={row} />
  }
};
